<template>
    <div class="list-no-data">
        <div class="list-no-data__icon"></div>
        <div
            :style="{width: textLength}"
            class="list-no-data__text"
        >
            {{text}}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            default: '暂无数据'
        },
        textLength: {
            type: String,
            default: '100%'
        }
    }
};
</script>
<style lang="less" scoped>
.list-no-data {
    position: relative;
    padding-top: 19px;
    text-align: center;
    margin-top: 20px;

    &__icon {
        position: relative;
        margin: 0 auto 30px;
        width: 150px;
        height: 180px;
        background: url('https://i.gsxcdn.com/1720099357_qaa9q2yp.png') no-repeat;
        background-size: 100%;
        background-repeat: no-repeat;
    }

    &__text {
        color: #717274;
        font-size: 16px;
        height: 22px;
        line-height: 22px;
        margin: 0 auto;
    }
}
</style>
